import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragHandle6Dot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.5 4.5C6.05228 4.5 6.5 4.05228 6.5 3.5C6.5 2.94771 6.05228 2.5 5.5 2.5C4.94771 2.5 4.5 2.94771 4.5 3.5C4.5 4.05228 4.94771 4.5 5.5 4.5ZM5.5 9C6.05228 9 6.5 8.55228 6.5 8C6.5 7.44772 6.05228 7 5.5 7C4.94771 7 4.5 7.44772 4.5 8C4.5 8.55228 4.94771 9 5.5 9ZM6.5 12.5C6.5 13.0523 6.05228 13.5 5.5 13.5C4.94771 13.5 4.5 13.0523 4.5 12.5C4.5 11.9477 4.94771 11.5 5.5 11.5C6.05228 11.5 6.5 11.9477 6.5 12.5ZM10.5 4.5C11.0523 4.5 11.5 4.05228 11.5 3.5C11.5 2.94771 11.0523 2.5 10.5 2.5C9.94772 2.5 9.5 2.94771 9.5 3.5C9.5 4.05228 9.94772 4.5 10.5 4.5ZM10.5 9C11.0523 9 11.5 8.55228 11.5 8C11.5 7.44772 11.0523 7 10.5 7C9.94772 7 9.5 7.44772 9.5 8C9.5 8.55228 9.94772 9 10.5 9ZM11.5 12.5C11.5 13.0523 11.0523 13.5 10.5 13.5C9.94772 13.5 9.5 13.0523 9.5 12.5C9.5 11.9477 9.94772 11.5 10.5 11.5C11.0523 11.5 11.5 11.9477 11.5 12.5Z",
		fill: "currentColor"
	})
});
export default SvgDragHandle6Dot;
